export default {
  namespaced: true,
  state:{    
    customers: [],    
    customerCreate: {
      modal: false,
      values: {}
    },
    customerEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    customers(state){
      return state.customers;
    },   
    customerCreate(state) {
        return state.customerCreate
    },
    customerEdit(state) {
      return state.customerEdit
    }    
  },
  mutations:{
    SET_CUSTOMERS(state, values){
      state.customers = values;
    },
    SET_CUSTOMER_CREATE_MODAL(state, value) {
      state.customerCreate.modal = value
    },
    SET_CUSTOMER_CREATE_VALUES(state, value) {
      state.customerCreate.values = value
    },
    SET_CUSTOMER_EDIT_MODAL(state, value) {
      state.customerEdit.modal = value
    },
    SET_CUSTOMER_EDIT_VALUES(state, value) {
      state.customerEdit.values = value
    },
    PUSH_CUSTOMER(state, value){
      state.customers.push(value);
    },    
    SET_UPDATE_CUSTOMER(state, values){
      var editedIndex = state.customers.map(customer => customer.id).indexOf(values.id)      
      if (editedIndex > -1){
        Object.assign(state.customers[editedIndex], values)              
      }
      return;
    },
    SPLICE_CUSTOMER(state, value){
      let i = state.customers.map(customer => customer.id).indexOf(value)      
      state.customers.splice(i, 1)
    }
  },
  actions:{
    getCustomers({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/clientes').then((response) => {
          commit('SET_CUSTOMERS', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    customerCreate({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/clientes/create').then((response) =>{
          commit('SET_CUSTOMER_CREATE_VALUES', response.data.data)
          commit('SET_CUSTOMER_CREATE_MODAL', true)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    customerStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/clientes', formData).then((response) => {
          commit('PUSH_CUSTOMER', response.data.data);
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    customerEdit({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.get('admin/clientes/' + value + '/edit').then((response) =>{
          commit('SET_CUSTOMER_EDIT_VALUES', response.data.data)
          commit('SET_CUSTOMER_EDIT_MODAL', true)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    customerUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/clientes/' + value, payload).then((response) => {          
          commit('SET_UPDATE_CUSTOMER', response.data.data);
          resolve(response)   
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    deleteCustomer({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/clientes/' + value).then((response) => {
          commit('SPLICE_CUSTOMER', value);
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      });      
    },
  }
}